/* eslint-disable react/prop-types */
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faArrowRight,
  faArrowUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';
import ClientService from '../../../Services/ClientService';
import FortnoxLogo from '../../../Images/Logos/fortnox-svg.svg';
import VismaLogo from '../../../Images/Logos/Visma_spcs_logo.svg';
import BjornLundenLogo from '../../../Images/Logos/Bjorn-Lunden-logo.png';
// import HogiaLogo from '../../../Images/Logos/hogia-logo.png';
import CardButton from '../../../Components/CardButton/CardButton';
import {
  XpektorForm,
  FormInput,
  FormButton,
} from '../../../Components/XpektorForms/XpektorForms';

const gT = (t, key) =>
  t(`page-external-authorization.accounting-auth-step${key}`);
const gsT = (t, key) => t(`shared${key}`);

export default function AccountingAuthStep({
  completed,
  redirectToFortnox,
  redirectToVisma,
  onValidation,
  error,
  errorText,
  extStateId,
  t,
}) {
  const [keyInput, setKeyInput] = useState('');
  const [inputError, setInputError] = useState('');
  const [validatingBL, setValidatingBL] = useState();
  // const [validatingHogia, setValidatingHogia] = useState();

  const validateBjornLunden = async (event) => {
    event.preventDefault();

    if (keyInput.length === 0) {
      setInputError(gT(t, '.error.empty-field'));
      return;
    }

    setValidatingBL(true);
    await ClientService.authenticateAccounting(keyInput, 3, extStateId)
      .then(() => {
        onValidation();
      })
      .catch(() => {
        setInputError(gT(t, '.error.found-no-connection'));
      })
      .finally(() => {
        setValidatingBL(false);
      });
  };

  return (
    <div className="auth-step">
      {completed ? (
        <div className="auth-step-completed-content">
          <FontAwesomeIcon
            className="auth-complete-icon"
            icon={faCircleCheck}
          />
          <p className="auth-complete-header">
            {gT(t, '.auth-complete-header')}
          </p>
        </div>
      ) : (
        <>
          <p className="auth-step-header">{gT(t, '.auth-step-header')}</p>
          <p className="auth-step-description">
            {gT(t, '.auth-step-description')}
            <br />
            <br />
            <i>{gT(t, '.auth-step-description-extra')}</i>
          </p>
          <button
            type="button"
            className="auth-step-help-link"
            onClick={() =>
              window.open('/tutorials', '_blank', 'noopener,noreferrer')
            }
          >
            <p>{gT(t, '.auth-step-help-link')}</p>
            <FontAwesomeIcon
              className="auth-step-help-link-icon"
              icon={faArrowUpRightFromSquare}
            />
          </button>
          {error && (
            <div className="auth-step-error">
              <p>
                {errorText ?? gT(t, '.error.connecting-accounting')}&nbsp;
                <a href="/tutorials" target="_blank" rel="noopener noreferrer">
                  {gT(t, '.tutorials-link')}
                </a>
              </p>
            </div>
          )}
          <div className="integration-options-column">
            <CardButton
              textHeader={gT(t, '.card-btn.fortnox.th')}
              textContent={gT(t, '.card-btn.fortnox.tc')}
              icon={faArrowRight}
              image={FortnoxLogo}
              onClick={redirectToFortnox}
            />
            <CardButton
              textHeader={gT(t, '.card-btn.visma.th')}
              textContent={gT(t, '.card-btn.visma.tc')}
              icon={faArrowRight}
              image={VismaLogo}
              onClick={redirectToVisma}
            />
            <CardButton
              textHeader={gT(t, '.card-btn.bjorn-lunden.th')}
              textContent={gT(t, '.card-btn.bjorn-lunden.tc')}
              icon={faArrowRight}
              image={BjornLundenLogo}
              onClick={() => {
                setKeyInput('');
                setInputError('');
              }}
              expandedContent={
                <>
                  <XpektorForm onSubmit={validateBjornLunden}>
                    <FormInput
                      label={gT(t, '.form-input-label.public-key')}
                      type="text"
                      value={keyInput}
                      onChange={(e) => setKeyInput(e.target.value)}
                      infoText={inputError}
                      t={t}
                    />
                    <FormButton
                      text={
                        validatingBL
                          ? gsT(t, '.actions.validating')
                          : gsT(t, '.actions.validate')
                      }
                      disabled={validatingBL}
                    />
                  </XpektorForm>
                  <a
                    href="/tutorials?as=bl"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="additional-link"
                  >
                    {gT(t, '.how-to-link')}
                  </a>
                </>
              }
            />
            {/* <CardButton
              textHeader="Hogia"
              textContent="Kräver en integrationslicens i Hogia"
              icon={faArrowRight}
              image={HogiaLogo}
              onClick={() => {
                setKeyInput('');
                setInputError('');
              }}
              expandedContent={
                <XpektorForm onSubmit={validateHogia}>
                  <XpektorForm.Input
                    label="Public key"
                    placeholder="Ex: 0a303ec5-80ff-4041-a721-d04ba67d3eec"
                    type="text"
                    value={keyInput}
                    onChange={(e) => setKeyInput(e.target.value)}
                    infoText={inputError}
                  />
                  <XpektorForm.Button
                    text={validatingHogia ? 'Validerar...' : 'Validera'}
                    disabled={validatingHogia}
                  />
                </XpektorForm>
              }
            /> */}
          </div>
        </>
      )}
    </div>
  );
}
